export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-heart-8998d350810e9780d246480429dbf9d7.svg";